import ModalSafariRedirect from './safari-redirect-modal';

export default ModalSafariRedirect;